import * as React from "react"
import { Link } from "gatsby"

import logo from "../images/logo-oneline.svg"

const Footer = () => (
  <footer className="footer-area section-padding">
    <div className="container">
      <div className="row">
        <div className="col-md-6 col-lg-3 col-sm-6 col-xs-12 wow fadeInUp" data-wow-delay="0.2s">
          <h3><img src={logo} alt="SRE NEXT" /></h3>
          <p>
            SRE NEXTとは、信頼性に関するプラクティスに深い関心を持つエンジニアのためのコミュニティベースのカンファレンスです。
          </p>
        </div>
        <div className="col-md-6 col-lg-3 col-sm-6 col-xs-12 wow fadeInUp" data-wow-delay="0.4s">
          <h3>QUICK LINKS</h3>
          <ul>
            <li><Link to="/#about">About</Link></li>
            <li><Link to="/speakers">Speakers</Link></li>
            <li><Link to="/schedule">Schedule</Link></li>
            <li><Link to="/#sponsors">Sponsors</Link></li>
            <li><Link to="/jobs">Jobs</Link></li>
            <li><Link to="/#coc">Code of Conduct</Link></li>
            <li><Link to="/#team">Team</Link></li>
          </ul>
        </div>
        <div className="col-md-6 col-lg-3 col-sm-6 col-xs-12 wow fadeInUp" data-wow-delay="0.6s">
          <h3>PAST EVENTS</h3>
          <ul>
            <li><a href="/2020/">SRE NEXT 2020</a></li>
          </ul>
          <br />
          <h3>NEXT EVENT</h3>
          <ul>
            <li><a href="/2023/">SRE NEXT 2023</a></li>
          </ul>
        </div>
        <div className="col-md-6 col-lg-3 col-sm-6 col-xs-12 wow fadeInUp" data-wow-delay="0.8s">
          <h3>FOLLOW US ON</h3>
          <div className="widget">
            <ul className="footer-social">
              <li><a className="twitter" href="https://twitter.com/srenext" target="_blank" rel="noreferrer"><i className="lni-twitter-filled" aria-label="Twitter"></i></a></li>
              <li><a className="slack" href="https://join.slack.com/t/srelounge/shared_invite/enQtNTEwNjMxODEzOTQzLTViZTY5YWU1OTQ3OGU5OTkwZjc0NDAyMThlNTYyZGJlN2MyNDJjM2MwODU0NjI3YTUyN2UwMGM1MDA2MDIyNmM" target="_blank" rel="noreferrer"><i className="lni-slack" aria-label="Slack"></i></a></li>
              <li><a className="hatena" href="https://blog.sre-next.dev/" target="_blank" rel="noreferrer"><i aria-label="Blog">&nbsp;</i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
